import React from 'react';
import type { MonitorAlert } from '../../shared/protocol';

export const alertTotal = (a?: MonitorAlert): number =>
  a ? a.hidden + a.blur + a.paste + a.copy : 0;

const KINDS: { key: 'hidden' | 'blur' | 'paste' | 'copy'; label: string }[] = [
  { key: 'hidden', label: 'salió de la pestaña' },
  { key: 'blur', label: 'perdió el foco' },
  { key: 'paste', label: 'pegó' },
  { key: 'copy', label: 'copió' },
];

/** Contadores de avisos de un jugador. Sin avisos, no pinta nada (salvo `showZero`). */
export const AlertChips: React.FC<{ alert?: MonitorAlert; showZero?: boolean }> = ({
  alert,
  showZero,
}) => {
  const shown = KINDS.filter((k) => showZero || (alert?.[k.key] ?? 0) > 0);
  if (shown.length === 0) return null;
  return (
    <span className="flex flex-wrap gap-1.5 mt-1">
      {shown.map((k) => (
        <span
          key={k.key}
          className={`chip text-[11px] ${
            (alert?.[k.key] ?? 0) > 0
              ? 'border-ember-500 bg-ember-500/15 text-ember-300'
              : 'border-ink-700 bg-ink-850 text-ink-500'
          }`}
        >
          {alert?.[k.key] ?? 0}× {k.label}
        </span>
      ))}
    </span>
  );
};
